import { get } from 'lodash';
import {
    INSURANCE_NOT_TAKEN_WARNING,
    IN_NETWORK_ONLY_REQUIREMENT,
} from '../AppointmentRequirements/constants';
import bookingStateSelector from '../../selectors/BookingStateSelector';
import initialBookingStateSelector from '../../selectors/InitialBookingStateSelector';
import appointmentDetailsMapStateToProps from '../../pages/AppointmentDetails/mapStateToProps';
import { DOCTOR_CARD_ROOT_KEY } from '../../constants';
import { getRequirement } from '../../components/AppointmentRequirements/helpers';

const getDescriptionText = bookingState => {
    const requirements = get(bookingState, 'requirements', []);
    const insuranceReq = requirements.find(
        req => req.key === INSURANCE_NOT_TAKEN_WARNING
    );
    return get(insuranceReq, 'suggested_message');
};

const checkIfPlanIsValid = plan => !!plan && parseInt(plan, 10) > 0;

export const mapStateToProps = state => {
    const bookingState = bookingStateSelector(state);

    const requirements = get(bookingState, 'requirements', []);
    const insurancePlanId = get(bookingState, 'insurance_plan_id', '-1');
    const insuranceCarrierId = get(bookingState, 'insurance_carrier_id', '-1');

    const bookingInitialState = initialBookingStateSelector(state);
    const whiteLabelVanityUrl = bookingInitialState?.vanityUrl;

    const isValidPlan = checkIfPlanIsValid(insurancePlanId);
    const insuranceReq = requirements.find(
        req => req.key === INSURANCE_NOT_TAKEN_WARNING
    ) || { value: true };
    const showModal = !insuranceReq.value && isValidPlan;

    const inNetworkOnlyBookableText = get(
        getRequirement(IN_NETWORK_ONLY_REQUIREMENT, requirements),
        'key',
        null
    );
    const isOnlyInNetworkBookable = Boolean(inNetworkOnlyBookableText);

    const professional = state[DOCTOR_CARD_ROOT_KEY].professional || {};
    const appointmentDetails = appointmentDetailsMapStateToProps(state);
    const {
        insuranceName,
        procedureId,
        professionalName,
        insuranceCarrierName,
        insurancePlanName,
    } = appointmentDetails;

    return {
        descriptionText: getDescriptionText(bookingState),
        insuranceCarrierId,
        insuranceName,
        insurancePlanId,
        procedureId,
        insuranceCarrierName,
        insurancePlanName,
        professional,
        professionalName,
        showModal,
        whiteLabelVanityUrl,
        isOnlyInNetworkBookable,
    };
};
